export default __webpack_public_path__ + "static/media/Crossbow of the Archaeologian.b1c2df74.jpg";